// extracted by mini-css-extract-plugin
export default {"account":"AccountItem_account__N1aBJ","icon":"AccountItem_icon__94mp+","folderIcon":"AccountItem_folderIcon__ngOHf","fontSize":"AccountItem_fontSize__6StQQ"};